import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { IconNames } from '@icon/assets';
import { UIIconComponent } from '@design-system';
import { filter, map } from 'rxjs/operators';
import { isMainNavActive } from '../../models/main-nav.utils';
import { WalletBuyingPowerBarComponent } from '../../modules/wallet/components/wallet-buying-power-bar/wallet-buying-power-bar.component';
import { FooterEventConsumerService } from './events/footer-event-consumer.service';

interface MenuItem {
	title: string;
	icon: IconNames;
	route: string;
}

@Component({
	selector: 'app-footer',
	imports: [UIIconComponent, RouterLink, WalletBuyingPowerBarComponent],
	templateUrl: './footer.component.html'
})
export class FooterComponent {
	private readonly router = inject(Router);
	private readonly footerEventConsumer = inject(FooterEventConsumerService);

	readonly visible = computed(() => this.footerEventConsumer.configuration().visible);

	readonly currentMenu = toSignal(
		this.router.events.pipe(
			filter((e): e is NavigationEnd => e instanceof NavigationEnd),
			map(e => e.urlAfterRedirects)
		),
		{ initialValue: this.router.url }
	);

	readonly menuItems: MenuItem[] = [
		{ title: 'بازار', icon: 'market-view', route: '/market' },
		{ title: 'پرتفوی', icon: 'portfolio', route: '/portfolio' },
		{ title: 'سفارش‌ها', icon: 'basket', route: '/orders' },
		{ title: 'کیف پول', icon: 'wallet', route: '/wallet' },
		{ title: 'سایر', icon: 'more', route: '/menu' }
	];

	isActiveMenu(item: MenuItem): boolean {
		return isMainNavActive(this.currentMenu(), item.route);
	}

	getMenuIcon(item: MenuItem): IconNames {
		return (item.icon + (this.isActiveMenu(item) ? '-fill' : '')) as IconNames;
	}

	selectedMenuClass(item: MenuItem): string {
		return this.isActiveMenu(item) ? 'text-gray-900 font-bold' : 'text-gray-500';
	}
	//TODO: Remove, just for pipeline test
}
